import { render, staticRenderFns } from "./ServicesManagement.vue?vue&type=template&id=2f136ef6&"
import script from "./ServicesManagement.vue?vue&type=script&lang=js&"
export * from "./ServicesManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports